import { launchUser } from '@/platform';

function readUser(field: 'first_name' | 'last_name' | 'id'): string {
  return String(launchUser()?.[field] ?? '');
}

export const FIRST_NAME = readUser('first_name');

export const LAST_NAME = readUser('last_name');

export const USER_ID = readUser('id');
